import React from 'react';
import Footer from "./Footer";
import '../styles/About.css';

const About = () => {
  return (
    <>
    <div className="about-page">
  <div className="about-container">
    {/* Hero Section */}
    <section className="about-hero">
      <h1>🙋 About Us</h1>
      <p className="hero-tagline">We make gaming fun, free, and responsible.</p>
      <div className="hero-description">
        <p>Silvertidequest is a Nederland platform for social casino games – created for those who love gaming but want a safe and money-free experience.</p>
      </div>
    </section>

    {/* Features Section */}
    <section className="features-section">
      <h2>We offer a wide selection of casino-inspired games that are:</h2>
      <div className="features-grid">
        <div className="feature-card">
          <span className="feature-icon">🆓</span>
          <h3>100% free to play</h3>
        </div>
        <div className="feature-card">
          <span className="feature-icon">🎲</span>
          <h3>For entertainment purposes</h3>
        </div>
        <div className="feature-card">
          <span className="feature-icon">❌</span>
          <h3>No real money, no betting, no prizes</h3>
        </div>
      </div>
    </section>

    {/* Values Section */}
    <section className="values-section">
      <h2>🎯 What We Stand For</h2>
      <div className="values-grid">
        <div className="value-card">
          <div className="value-header">
            <span className="value-icon">🎮</span>
            <h3>Pressure-free gaming</h3>
          </div>
          <p>We believe gaming should be fun – not tied to risk, loss, or spending money.</p>
        </div>

        <div className="value-card">
          <div className="value-header">
            <span className="value-icon">🔞</span>
            <h3>For adults (18+)</h3>
          </div>
          <p>This platform is intended for adults only. We promote responsible use and include no elements of gambling.</p>
        </div>

        <div className="value-card">
          <div className="value-header">
            <span className="value-icon">🛡️</span>
            <h3>Safety and transparency</h3>
          </div>
          <p>We do not collect personal payment information. All processed data is anonymous and complies with GDPR and Nederland law.</p>
        </div>
      </div>
    </section>

    {/* Contact Section */}
    <section className="contact-section">
      <h2>📍 Our Location</h2>
      <div className="contact-card">
        <div className="company-info">
          <h3>Silvertidequest AS</h3>
          <p>	Assen Drenthe Brink 23</p>
          <p>	9401 HT Assen,Netherlands</p>
        </div>
        <div className="contact-details">
          <p><span>📧</span> Email: <a href="mailto:Silvertidequest@gmail.com">Silvertidequest@gmail.com</a></p>
          <p><span>📞</span> Phone: <a href="tel:+31365336736">+31 36 533 6736</a></p>
        </div>
      </div>
    </section>
  </div>
</div>

      <Footer />
    </>
  );
};

export default About;
